export const Z_LAYERS = {
  top: "1102",
  menu: "42", //Max number where nav is still under modal background
  bottom: "-1",
} as const;

/** Values are in Pixels */
export enum MaxBreakPoints {
  /** For mobile screens */
  MEDIUM = 767,
  /** For tablet screens */
  LARGE = 1023,
}
